import { Title } from 'src/features/home/components/title/title';
import { StyledDescription } from 'src/features/home/home.styles';
import { brandsList } from 'src/features/home/components/brands/brands.constants';
import { Logo, StyledBrandsContainer } from 'src/features/home/components/brands/brands.styles';
export const Brands = () => <div data-sentry-component="Brands" data-sentry-source-file="brands.tsx">
    <Title title="Trusted By" isLeft data-sentry-element="Title" data-sentry-source-file="brands.tsx" />
    <StyledDescription isLeft fullWidth data-sentry-element="StyledDescription" data-sentry-source-file="brands.tsx">
      Join hundreds of organisations upskilling their workforce with TryHackMe.
    </StyledDescription>
    <StyledBrandsContainer data-sentry-element="StyledBrandsContainer" data-sentry-source-file="brands.tsx">
      {brandsList.map(({
      name,
      image
    }) => <Logo alt={name} src={image} key={name} />)}
    </StyledBrandsContainer>
  </div>;